import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio-showcase',
  templateUrl: './portfolio-showcase.component.html',
  styleUrls: ['./portfolio-showcase.component.scss']
})
export class PortfolioShowcaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
